import styles from './RegModeSelf.module.css'
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ReduxStateInt, setOrderData, setSlider} from "../../Reducer/GlobalReducer";
import SelectNumber, {SimCardUnitInt} from "../SelectNumber/SelectNumber";
import RuPersonalData, {PersonalDataInt} from "../PersonalData/PersonalData";
import Payment, {PaymentInt} from "../Payment/Payment";
import ClientInfoItem from "../ClientInfoItem/ClientInfoItem";
import DeliveryItem from "../DeliveryItem/DeliveryItem";
import RuPersonalDataDelivery from "../PersonalDataDelivery/PersonalDataDelivery";
import Coupon from "../Coupon/Coupon";
import {useNavigate} from "react-router-dom";
interface RegModeOnePropsInt
{
    parentWidth?:number
}

export default function RegModeSelf({parentWidth}:RegModeOnePropsInt){
    const [error,setError] = useState("")
    const navigate = useNavigate()

    const dataCardItem = useSelector((state: ReduxStateInt) => {
        return state.slider?.dataCardItem
    })
    const prefDomain = useSelector((state: ReduxStateInt) => {
        return state.prefDomain
    })
    const [showDetails, setShowDetails] = useState(true)


    const dispatch = useDispatch()
    const orderData = useSelector((state: ReduxStateInt) => {
        return state.orderData
    })
    const [selectedCtn,setSelectedCtn] = useState<SimCardUnitInt>()


    const region = useSelector((state: ReduxStateInt) => {
        return state.baseRegion
    })

    const [stage, setStage] =useState(0)

    useEffect(()=>{
        setStage(0)
    },[region.makeSelectRegion])

    useEffect(()=>{
        if(stage === 0)
        {
            dispatch(setOrderData({}))
        }
    },[orderData?.tarifData?.tarifId])

    useEffect(()=>{
        if(prefDomain?.skipCoupon || !dataCardItem?.useCoupon) setStage(2)
    },[prefDomain, dataCardItem])


    const stageNumberSelectResult = (sim:SimCardUnitInt | undefined)=>{
        setStage(2)
    }

    const stageCouponResult = ()=>{
        setStage(2)
    }


    const stagePersonalDataResult = ( )=>{

        setStage(3)
    }

    const stagePaymentResult = (data: PaymentInt) =>{
        setStage(5)
    }

    const stageDeliveryResult = ()=>{
        setStage(4)
        setShowDetails(true)
    }

    const ctnData = orderData?.ctnData

    if(stage === 5) return (
        <ClientInfoItem/>
    )

    const useCoupon = !! dataCardItem?.useCoupon
    const xPrice = orderData?.tarifData?.newPrice !== undefined ? orderData?.tarifData?.newPrice : orderData?.tarifData?.price
    const actPrice = dataCardItem?.bundleOne?.actCost ? dataCardItem?.bundleOne?.actCost : 0

    const selfRegMode = orderData?.regMode === 1 || orderData?.regMode===2
    return(

        <div className={[styles.orderCont, styles.orderContBorder].join(' ')} >

            <div className={styles.orderOneStageCont}>
                {showDetails &&

                    <>
                        <div className={styles.orderLine}>
                            <div >Режим :</div>
                            <span className={styles.span}>Новая сим карта</span>
                        </div>
                        <div className={styles.orderLine}>
                            <div >Оператор :</div>
                            <span className={styles.span}>{orderData?.tarifData?.operName}</span>
                        </div>
                        <div className={styles.orderLine}>
                            <div >Ваш тариф :</div>
                            <span className={styles.span}>{orderData?.tarifData?.name}</span>
                        </div>

                        <div className={styles.orderLine}>
                            <div >Регион подключения :</div>
                            <span className={styles.span}>{orderData?.regionData?.macroRegionName?.replace(/Регион :/ui,'')}</span>
                        </div>

                        {orderData?.couponId &&
                            <div className={styles.orderLine}>
                                <div >Примененный купон</div>
                                <span className={[styles.span, styles.blueColor].join(' ')}>{orderData?.couponId}</span>
                            </div>
                        }


                        <div className={styles.orderLine}>
                            <div >Стоимость подключения на тариф:</div>
                            <span className={[styles.redColor,styles.span].join(' ')}>{xPrice + " руб."}</span>
                        </div>

                        { actPrice > 0 &&
                            <div className={styles.orderWar}>
                                <div>Внимание, оператор {orderData?.tarifData?.operName?.toLowerCase()} взимает <span>единоразовую</span> плату за активацию номера в размере {actPrice + " руб."}</div>
                            </div>

                        }

                        { selfRegMode &&
                            <div className={styles.orderLine}>
                                <div >Режим саморегистрации :</div>
                                <span className={styles.span}>Да</span>
                            </div>

                        }

                        { stage>2 &&
                            <div className={styles.orderLine}>
                                <div>Данные для доставки :</div>
                                <span className={styles.span}>ОК</span>
                            </div>
                        }
                        { stage>3 &&
                            <div className={styles.orderLine}>
                                <div >Стоимость доставки :</div>
                                <span className={styles.span}>{orderData?.deliveryData?.price + " руб."}</span>
                            </div>
                        }
                        { stage>4 &&
                            <div className={styles.orderLine}>
                                <div >Платеж :</div>
                                <span className={styles.span}>{orderData?.paymentData?.amount + " руб."}</span>
                            </div>
                        }
                        { stage>4 &&
                            <div className={styles.orderLine}>
                                <div >Ваш номер заказа :</div>
                                <span className={styles.span}>{orderData?.orderId}</span>
                            </div>
                        }

                    </>


            }

            </div>



            {stage===0 &&

                <div className={styles.btnCont}>

                    <button type="button" className="btn btn-face "
                            onClick={()=>{
                                dispatch(setSlider({sliderMode:0}))
                                navigate('/')
                            }}
                    >Отменить</button>

                    <button type="button" className="btn btn-face "
                            onClick={()=>{
                                setShowDetails(false)
                                setStage(2)
                            }} // на персональные данные
                    >Продолжить</button>

                </div>

            }



            {stage===1 &&
                <SelectNumber cbExecute={stageNumberSelectResult}/>

            }

            {stage===2 &&
                <RuPersonalDataDelivery cbExecute={stagePersonalDataResult}/>
            }


            {stage===3 &&
                <DeliveryItem cbExecute={stageDeliveryResult} contWidth={ parentWidth ? parentWidth : 0 } />
            }

            {stage===4 &&
                <Payment cbExecute={stagePaymentResult}></Payment>
            }

            {stage === -1 &&
                <div>{error}</div>
            }

        </div>

    )
}